import { jsx } from 'react/jsx-runtime';

const SvgMiscBoltOutlined = (props) => jsx("svg", Object.assign({ xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 24 24", height: props.size, width: props.size }, props, { children: jsx("path", { fill: "#2D2E2E", d: "M12 2a10 10 0 1 0 0 20 10 10 0 0 0 0-20Zm0 18a8 8 0 1 1 0-16 8 8 0 0 1 0 16Zm1-14-5.87 7H11v5l5.87-7H13V6Z" }) }));

export { SvgMiscBoltOutlined as default };
//# sourceMappingURL=MiscBoltOutlined.es.js.map
